import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Grid from '@mui/material/Grid';
import ReactMarkdown from 'react-markdown';
import Icon from '/@/components/icon';
import settings from '/@/core/settings';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

const IconText = ({ type = 'check', text, withTheme, separation, bigFontSize = false }) => {
    return (
        <Grid container justifyContent='flex-start' alignItems='flex-start' sx={{ mb: separation ? 1 : 0 }}>
            <Grid item sx={{ paddingRight: bigFontSize ? 2 : 1 }}>
                <CheckCircleOutlineIcon sx={{ color: (t) => t.palette.primary.main, fontSize: 20 }} />
            </Grid>
            <Grid item xs={10}>
                <Title
                    className={bigFontSize ? styles.big : styles.title}
                    bolder
                    theme={withTheme && settings.app.theme}
                >
                    <ReactMarkdown className={styles.markdown}>{text}</ReactMarkdown>
                </Title>
            </Grid>
        </Grid>
    );
};

export default IconText;
